import Button from '@components/Button';
import Map from '@components/Map';
import useProject from '@hooks/useProject';
import { useFlow } from '@router/stackflow';
import { useAtomValue } from 'jotai';

import useOnBoundChange from './hooks/useOnBoundChange';
import styles from './styles.module.scss';
import { locationAgreedAtom, userLatLonAtom } from '../../../atoms/shopsInMapAtoms';

interface Props {
    markers?: MarkerProps[];
    isOrder?: boolean;
    next?: string;
}

function ShopMap({ markers, isOrder }:Props) {
  const { push } = useFlow();

  const handleMarkerClick = (
    id?: string,
    lat?: number,
    lng?: number,
  ) => {
    if (isOrder) {
      push('ShopLocationBottomSheet', {
        shopId: id!,
        lat,
        lng,
      });
    } else {
      push('ShopDetailBottomSheet', {
        shopId: id!,
      });
    }
  };
  const onBoundChange = useOnBoundChange();
  const location = useAtomValue(userLatLonAtom);
  const locationAgreed = useAtomValue(locationAgreedAtom);
  const project = useProject();
  const defaultLocation = { lat: project?.lat || 37.4811291019439, lng: project?.lon || 126.895303784633 };
  return (
        <div className={styles.wrapper}>
            <Map center={(location.lat !== 0 && locationAgreed) ? {
              lat: location.lat,
              lng: location.lon,
            } : defaultLocation}
                 height={326}
                 onMarkerClick={handleMarkerClick}
                 onBoundChange={onBoundChange}
                 showMyLocation={locationAgreed}
                 markers={markers} />
            {(!locationAgreed) && (
                <Button className={styles.agree}
                        onClick={() => push('AccountSettingActivity', {})}
                        size='sm'>
                    위치 정보 사용 동의하기
                </Button>
            )}
        </div>
  );
}

export default ShopMap;
